// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3paZk","title":"Images90_title__WhDVG","images":"Images90_images__31wOj"};